import React, { useState, useEffect, useRef } from "react";
import SbEditable from "storyblok-react";
import Addresses from "./Addresses";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Locations = (props) => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <Disclosure as="div" className="pt-4">
      {({ open }) => (
        <>
          <dt className="text-lg border-b pb-3">
            <Disclosure.Button className="group text-left w-full flex justify-between items-start">
              <h5
                className={classNames(
                  open ? "text-darkgrey" : "text-darkgrey",
                  "font-display uppercase lg:text-2xl text-2xl tracking-normal group-hover:text-red-800 mb-0 duration-500"
                )}
              >
                {props.title}
              </h5>
              <span className="h-7 flex items-center">
                <ChevronDownIcon
                  className={classNames(
                    open
                      ? "-rotate-180 text-red-800"
                      : "rotate-0 text-darkgrey",
                    "h-6 w-6 transform transition-all duration-500 ease-in-out group-hover:text-red"
                  )}
                  aria-hidden="true"
                />
              </span>
            </Disclosure.Button>
          </dt>
          <dd className="mt-2">
            <div
              style={{ maxHeight: open ? height : 0 }}
              className={classNames(
                open ? "mb-4" : "mb-0",
                "relative overflow-hidden transform transition-all duration-500 ease-in-out"
              )}
            >
              <div
                className="mt-6 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4"
                ref={ref}
              >
                <Addresses {...props}></Addresses>
              </div>
            </div>
          </dd>
        </>
      )}
    </Disclosure>
  );
};

const ContactSimpleFourColumn = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative bg-white my-16 sm:my-20">
        <div className="flex flex-row flex-wrap max-w-screen-xl mx-auto">
          <div className="w-full px-6 mx-auto">
            <dl v-for="item in items" className="mt-1 space-y-1 last:pb-1">
              {blok.items.map((locations, i) => (
                <Locations {...locations} key={i}></Locations>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default ContactSimpleFourColumn;
